import { render, staticRenderFns } from "./imageToTextInfAi.vue?vue&type=template&id=16c7230f&scoped=true"
import script from "./imageToTextInfAi.vue?vue&type=script&lang=js"
export * from "./imageToTextInfAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c7230f",
  null
  
)

export default component.exports